'use client'
import React, { useContext, useState } from 'react';
import { Button, FormControl, FormErrorMessage, Input, Text } from '@chakra-ui/react';
import { Box, Flex } from '@chakra-ui/layout';
import { useForm } from 'react-hook-form';
import GoogleIcon from './googleIcon';
import { AuthContext } from '../lib/authContext';
import { Link, useSearchParams } from 'react-router-dom';
import useTranslation from '../../lib/i18n/useTranslation';
export default function SignUpForm(props) {
  const { onSubmitted } = props;
  const authContext = useContext(AuthContext);
  const [globalError, setGlobalError] = useState(null);
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');
  const arg = searchParams.get('arg');
  const { t } = useTranslation();
  const signInWithGoogle = async () => {
    try {
      await authContext.signInWithGoogle();
    } catch (e) {
      setGlobalError(e.message);
      console.error(e);
    }
  };
  const {
    handleSubmit,
    register,
    watch,
    formState: { isSubmitting, isValid, errors }
  } = useForm({ mode: 'onBlur' });
  const onSubmit = async (data) => {
    try {
      await authContext.signUp(data.email, data.password);
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      setGlobalError(e.message);
      console.error(e);
    }
  };
  return (
    <>
      <Flex
        flexDirection="column"
      >
        <form onSubmit={handleSubmit(onSubmit)} >
          <FormControl isInvalid={errors?.email} mb={2}>
            <Input
              placeholder={t('auth.email')}
              {...register('email', {
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: t('auth.invalidEmail')
                }
              })}
            />
            <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={errors?.password} mb={2}>
            <Input
              placeholder={t('auth.password')}
              type="password"
              {...register('password', {
                required: true,
                minLength: { value: 6, message: t('auth.passwordMinLength') }
              })}
            />
            <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
          </FormControl>
          <FormControl isInvalid={errors?.confirmPassword} mb={3}>
            <Input
              placeholder={t('auth.confirmPassword')}
              type="password"
              {...register('confirmPassword', {
                required: true,
                minLength: { value: 6, message: t('auth.passwordConfirmationMinLength') },
                validate: (val) => {
                  if (watch('password') != val) {
                    return t('auth.passwordsDoNotMatch');
                  }
                },
              })}
            />
            <FormErrorMessage>{errors.confirmPassword?.message}</FormErrorMessage>
          </FormControl>
          {globalError && (
            <Box mb={3}>
              <Text color={'text.medium.red'}>{globalError}</Text>
            </Box>
          )}
          <Text w="250px" fontSize="11px">
            {t('auth.termsText')}
          </Text>
          <Button
            mt={3}
            w="100%"
            variant={"coralFill"}
            type={'submit'}
            isLoading={isSubmitting}
            isDisabled={!isValid}
          >{t('auth.createAccount')}</Button>
        </form>
        <Flex
          mt={3}
          pt={3}
          flex={1}
          flexDirection={"column"}
          borderTop="1px solid"
          borderColor="divider.grey"
          alignItems={"center"}
        >
          <Button
                onClick={signInWithGoogle}
                variant="greyOutline"
                leftIcon={<GoogleIcon />} >
                {t('auth.signUpWithGoogle')}
          </Button>
          <Link to={("/auth/sign-in" + (redirectUrl ? '?redirect_url=' + redirectUrl : '') + (arg ? '&arg=' + arg : ''))}>
              <Button
                variant="coralTransparent"
                mt={3}
                textAlign={'center'}
              >
             {t('auth.goBackToSignIn')}
            </Button>
          </Link>
        </Flex>
      </Flex>
    </>
  );
}
